import { render } from "./StudentPlaceLink.vue?vue&type=template&id=ed6332da"
import script from "./StudentPlaceLink.vue?vue&type=script&lang=js"
export * from "./StudentPlaceLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__